
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Toasted from 'vue-toasted';
import { formatDurationSeconds } from "../../../util";
import { Board, Card, CardDuration, Ticket } from "../../backend/backendapi";
import { KanbanState } from "../kanban.model";
import { getDurationSecondsSum, getStartTime, getUserId } from "./util";
import CenterOnParent from "../../util/CenterOnParent";

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'RecentTimeTracker',
  components: { CenterOnParent },
})
export default class RecentTimeTracker extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;
  @Prop({ required: true })
  readonly board!: Board;
  @Prop({ required: true })
  readonly flow!: Ticket;
  @Prop({ required: true })
  readonly card!: Card;
  @Prop({ required: true })
  readonly duration!: CardDuration;

  //getter
  get startTime(): string {
    return getStartTime(this.card);
  }

  get totalDurationString(): string {
    return formatDurationSeconds(getDurationSecondsSum(this.card));
  }

  get userId(): string | undefined {
    return getUserId();
  }
}
